export default {"src":"/_next/static/media/verbrauch.d5b13b9d.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};